import {cloneDeep} from "lodash";
import {getString, resetObjectValues} from "Core/helpers/data";
import {ProcurementsItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ProcurementsItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ProcurementsItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {ProcurementsItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep(inputData);

	result = {
		id: result.id,
		name: result.name,
	};

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}